import { columns, mobileColumns } from './Column'
import ReactDataTable from '../../../../../../../components/_shared/Table/ReactDataTable'
import useWindowSize from '../../../../../../../../utils/hooks/useWindowSize'
import ReactExpandableTable from '../../../../../../../components/_shared/Table/ReactExpandableTable'
import { Alert } from 'react-bootstrap'
import ReportFooter from '../../ReportsFooter/ReportFooter'
import { Col, Row } from 'react-bootstrap'

const GetNewUserReportTable = ({
    isLoading,
    data,
    handleColumnSort,
    downloadPDF,
    setCurrentRow,
    currentRow,
    tableOptions,
    handlePageClick,
    handleRowsPerPage,
    pageCount,
    totaldata,
    downloadExcel,
    reportCode,
}) => {
    const size = useWindowSize()
    const totalUsers = totaldata || data?.length || 0

    const totalDevices =
        data?.reduce((sum, item) => sum + (item.device_count || 0), 0) || 0
    if (size.width < 768) {
        return (
            <>
                <h1 className="mb-4">New User Report</h1>
                <ReactExpandableTable
                    currentRow={currentRow}
                    isLoading={isLoading}
                    data={data}
                    mobileColumns={mobileColumns}
                    removePagination={false}
                    handleColumnSort={handleColumnSort}
                    setCurrentRow={setCurrentRow}
                    pageCount={pageCount}
                    activePage={tableOptions?.activePage}
                    rowPerPages={tableOptions?.rowPerPages}
                    totaldata={totaldata}
                    handleRowsPerPage={handleRowsPerPage}
                    handlePageClick={handlePageClick}
                />

                <ReportFooter
                    BackText={'Back'}
                    PdfText={'PDF'}
                     MailText={'Mail'}
                    ExcelText={'Excel'}
                    onPdfClick={downloadPDF}
                    onExcelClick={downloadExcel}
                    fallbackData={data}
                     reportCode={reportCode}
                />
            </>
        )
    }

    return (
        <>
            <h1 className="mb-4">New User Report</h1>

            <ReactDataTable
                isLoading={isLoading}
                data={data}
                columns={columns}
                removePagination={false}
                handleColumnSort={handleColumnSort}
                pageCount={pageCount}
                activePage={tableOptions?.activePage}
                rowPerPages={tableOptions?.rowPerPages}
                totaldata={totaldata}
                handleRowsPerPage={handleRowsPerPage}
                handlePageClick={handlePageClick}
            />

            <div className="p-3 my-3 rounded-lg shadow-sm border newReport">
                <Row className="align-items-center">
                    {/* New User Total */}
                    <Col className="d-flex justify-content-start align-items-center clrText">
                        <span className="me-2 text-lg fw-medium text-gray-700">
                            New User Total:
                        </span>
                        <span className="fw-semibold">{totalUsers}</span>
                    </Col>

                    {/* New Devices Total */}
                    <Col className="d-flex justify-content-start align-items-center clrText">
                        <span className="me-2 text-lg fw-medium text-gray-700">
                            New Devices Total:
                        </span>
                        <span className="fw-semibold">{totalDevices}</span>
                    </Col>
                </Row>
            </div>

            <ReportFooter
                BackText={'Back'}
                PdfText={'PDF'}
                 MailText={'Mail'}
                ExcelText={'Excel'}
                onPdfClick={downloadPDF}
                onExcelClick={downloadExcel}
                fallbackData={data}
                 reportCode={reportCode}
            />
        </>
    )
}

export default GetNewUserReportTable
